import { RefreshCw, TriangleAlert } from 'lucide-react'
import { ApiError } from '@/lib/api'

interface ErrorStateProps {
  error?: unknown
  onRetry?: () => void
  compact?: boolean
}

export function ErrorState({ error, onRetry, compact }: ErrorStateProps) {
  const bericht =
    error instanceof ApiError && error.message
      ? error.message
      : 'De gegevens konden niet geladen worden.'

  return (
    <div className={compact ? 'flex justify-center py-10' : 'flex justify-center py-20'}>
      <div className="flex max-w-sm flex-col items-center text-center">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-status-overbezet/10 text-status-overbezet">
          <TriangleAlert className="h-5 w-5" />
        </span>
        <p className="mt-3 text-sm font-medium text-ink">Er ging iets mis</p>
        <p className="mt-1 text-sm text-ink-faint">{bericht}</p>
        {onRetry ? (
          <button type="button" className="btn-ghost mt-4" onClick={onRetry}>
            <RefreshCw className="h-4 w-4" />
            Opnieuw proberen
          </button>
        ) : null}
      </div>
    </div>
  )
}
